import type { ComponentProps } from 'react';

import { TextField, theme } from '@theguarantors/tg-package-material-ui';

export type InviteLeaseDetailsTextInputProps = ComponentProps<typeof TextField>;

export const InviteLeaseDetailsTextInput = ({ sx, ...props }: InviteLeaseDetailsTextInputProps) => {
  return (
    <TextField
      color="secondary"
      {...props}
      sx={{
        display: 'flex',
        '& .MuiFormLabel-asterisk': {
          color: `${theme.palette.red[600]} !important`,
        },
        '& .MuiFormHelperText-root': {
          fontSize: '12px',
          lineHeight: '20px',
        },
        '& .MuiInputLabel-root': {
          [theme.breakpoints.down('md')]: {
            fontSize: '14px !important',
          },
        },
        ...sx,
      }}
    />
  );
};
